/**
 * The donor value set's colour group — mirror of donor.css's colour tokens.
 * ----------------------------------------------------------------------------
 * THE CSS IS THE SOURCE OF TRUTH; `values.js` is the mirror and exposes this
 * object as `donor.color` (and as `donorColor`), so `pnpm tokens:parity` checks
 * it exactly as before. It is a separate module only for bundling (CON-331):
 * the widgets reach it through `useBrandColors`, and a module is the unit a
 * bundler splits chunks by, so keeping it apart stops the whole values file
 * joining every widget's download. Values only, no imports.
 */
export const donorColor = {
  surface0: '#FFFFFF',
  surface1: '#F7F7F8',
  surface2: '#F7F7F8',
  surfaceSunken: '#EFEFF1',
  surfaceFaint: '#FBFBFC',
  overlaySurface: '#EFEFF1',
  checkoutBackdrop: 'rgba(244, 244, 245, 0.72)',
  placeholder: '#E4E4E7',
  placeholderStrong: '#D4D4D8',
  avatar1: '#E4E9E2',
  avatar2: '#E5E7EB',
  avatar3: '#EDE9E3',
  textPrimary: '#18181B',
  textSecondary: '#52525B',
  textTertiary: '#71717A',
  textMuted: '#71717A',
  borderControl: 'rgba(0, 0, 0, 0.1)',
  borderControlHover: 'rgba(0, 0, 0, 0.16)',
  borderControlSubtle: 'rgba(0, 0, 0, 0.06)',
  statusErrorText: '#DC2626',
  statusErrorBg: '#FEF2F2',
  statusErrorBorder: '#FECACA',
  statusSuccessText: '#047857',
  statusSuccessBg: '#ECFDF5',
  statusSuccessBorder: '#A7F3D0',
  statusWarningText: '#B45309',
  statusWarningBg: '#FFFBEB',
  statusWarningBorder: '#FDE68A',
  statusInfoText: '#2563EB',
  statusInfoBg: '#EFF6FF',
  statusInfoBorder: '#BFDBFE',
};
